/*
 * client_id → ブランド識別子 のマッピング。
 *
 * - "halmekUp":     既定ブランド（黄）。body に特別なクラスは付与しない。
 * - "halmekEvents": イベントブランド（緑）。body に "halmekEvents" クラスを付与すると halmek-custom.css が色を切り替える。
 *
 * ブラウザタブの title は BRAND_SITE_TITLES でブランドごとに切り替える（applyBrand が document.title を更新）。
 *
 * 環境ごとに client_id は異なるため、stg / prod / wrk など全環境分を列挙する。
 * 新クライアント追加時はここに 1 行追加 → React 側を再ビルド・デプロイ。
 *
 * client_id は ClientsTable（DynamoDB: amplifyIdentityBrokerClients-<env>）の値と一致させる。
 */
export const BRAND_MAPPING = {
	// stg
	"5vhjt0vuk6t2fvacrl3jt277mm": "halmekUp",      // halmkup_app_local
	"5qsn3gal0mvdkcqcgfkdg1itb0": "halmekUp",      // halmkup_app_clientWeb_dev
	"6o18egumvrkhcuoohk58ohvh4p": "halmekUp",      // halmkup_app_clientWeb
	"49s4n33cka1e36tnakserbf384": "halmekEvents",  // event_app_local
	"3p19oc31ms9t3u2f5k7ri7apkl": "halmekEvents",  // event_app_clientWeb

	// prod
	"34a4uj7baggnoadcgb5vnee4pp": "halmekUp",      // halmkup_app_clientWeb
	"2cnh5c50odfi8oi3e87ut0ciok": "halmekEvents",  // event_app_clientWeb

	// wrk
	"71vin5vt3cfmr4enohc8ao46i4": "halmekUp",      // halmkup_app_local
	"6q3ujl8gv7sn80r60k6csuh5m": "halmekUp",       // halmkup_app_clientWeb
	"5ht7ngh2fnj615pc6g7l104mle": "halmekEvents",  // event_app_local
	"37ag15j46kequ4auapqqnihnag": "halmekEvents",  // event_app_clientWeb
};

// ブランド識別子 → ブラウザタブの <title>（document.title）
export const BRAND_SITE_TITLES = {
	halmekUp: "HALMEK up（ハルメクアップ）",
	halmekEvents: "ハルメク events",
};

export const DEFAULT_SITE_TITLE = "HALMEK";

export function getBrandByClientId(clientId) {
	if (!clientId) return null;
	return BRAND_MAPPING[clientId] || null;
}

export function getSiteTitleByBrand(brand) {
	if (!brand) return DEFAULT_SITE_TITLE;
	return BRAND_SITE_TITLES[brand] || DEFAULT_SITE_TITLE;
}
